export class VadenJS {
  static NewFunctionName(parameter1: string): string {
    // Your code here
    return parameter1;
  }
 static ClearSearchParameter(): void {

        const url = new URL(window.location.href);

        // Parametreyi silmek yerine değerini boşalt
        url.searchParams.set("Ara", "");

        window.history.replaceState({}, "", url.toString());

    }
}
